// Vendor scripts
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Vue
import './vue/vue.js'

// Custom scripts
import './scripts/accordion-search'
import './scripts/alert'
import './scripts/animate-on-scroll'
import './scripts/autocomplete'
import './scripts/bootstrap-datepicker'
import './scripts/collapse-prevent-close'
import './scripts/confirmation-modal'
import './scripts/form'
import './scripts/header'
import './scripts/image-caption-toggle'
import './scripts/image-modal'
import './scripts/input-mask'
import './scripts/logout'
import './scripts/page-scroll'
import './scripts/print-card'
import './scripts/search'
import './scripts/swiper-config'
import './scripts/report-download'
import './scripts/spinner'
import './scripts/toggle'
import './scripts/video-modal'
import './scripts/utility-navigation-search'
